"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _CardContent = _interopRequireDefault(require("../CardContent"));

var _styled = require("./styled");

var MessageEditor = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(MessageEditor, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(MessageEditor);

  function MessageEditor() {
    (0, _classCallCheck2["default"])(this, MessageEditor);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MessageEditor, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          body = _this$props.body,
          placeholder = _this$props.placeholder,
          onChangeBody = _this$props.onChangeBody,
          submitButton = _this$props.submitButton,
          attachments = _this$props.attachments,
          attachmentPickers = _this$props.attachmentPickers,
          autoFocus = _this$props.autoFocus,
          inputRef = _this$props.inputRef,
          draftStatus = _this$props.draftStatus,
          error = _this$props.error,
          helperText = _this$props.helperText,
          inputProps = _this$props.inputProps,
          closeButton = _this$props.closeButton,
          onClickInput = _this$props.onClickInput;
      return /*#__PURE__*/_react["default"].createElement(_styled.Card, {
        error: error
      }, attachmentPickers && /*#__PURE__*/_react["default"].createElement(_styled.ActionsWrapper, {
        padding: "small"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        justify: "space-between",
        alignItems: "center",
        wrap: "nowrap"
      }, /*#__PURE__*/_react["default"].createElement(_styled.AttachmentPickersWrapper, {
        id: "".concat(id, "-attachment-pickers-wrapper"),
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 1,
        wrap: "nowrap"
      }, attachmentPickers)), closeButton && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, closeButton))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "column",
        spacing: 4
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_InputBase["default"], {
        id: "".concat(id, "-input-base"),
        autoFocus: autoFocus,
        inputRef: inputRef,
        multiline: true,
        fullWidth: true,
        placeholder: placeholder,
        value: body,
        onChange: onChangeBody,
        error: error,
        onClick: onClickInput,
        inputProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, inputProps), {}, {
          // We want both clicking the wrapper and the input itself to
          // trigger the onClickInput function
          onClick: onClickInput
        })
      })), attachments && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        id: "".concat(id, "-attachments-wrapper"),
        item: true,
        container: true,
        direction: "column",
        spacing: 3
      }, attachments), error && helperText && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
        error: true
      }, helperText)), (submitButton || draftStatus) && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 2,
        wrap: "nowrap",
        alignItems: "center",
        justify: "flex-end"
      }, draftStatus && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, draftStatus), submitButton && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        id: "".concat(id, "-submit-button-wrapper")
      }, submitButton))))));
    }
  }]);
  return MessageEditor;
}(_react["default"].PureComponent);

MessageEditor.defaultProps = {
  submitButton: undefined,
  attachments: undefined,
  attachmentPickers: undefined,
  autoFocus: false,
  inputRef: undefined,
  draftStatus: undefined,
  error: false,
  helperText: undefined,
  inputProps: {},
  closeButton: undefined,
  onClickInput: undefined
};
var _default = MessageEditor;
exports["default"] = _default;